// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("./IconV5.bs.js");
let DateFns = require("date-fns");
let CalendarDate = require("../../../reason/common/types/CalendarDate.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../ErrorHandling/UnselectedUnionMemberError.bs.js");
let AgentPropertyMlsStatus_mlsPlan_graphql = require("../../../__generated__/AgentPropertyMlsStatus_mlsPlan_graphql.bs.js");
let AgentPropertyMlsStatus_property_graphql = require("../../../__generated__/AgentPropertyMlsStatus_property_graphql.bs.js");

let convertFragment = AgentPropertyMlsStatus_mlsPlan_graphql.Internal.convertFragment;

let convertFragment$1 = AgentPropertyMlsStatus_property_graphql.Internal.convertFragment;

function AgentPropertyMlsStatus$MlsStatus(props) {
  let __size = props.size;
  let detailText = props.detailText;
  let size = __size !== undefined ? __size : "md";
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx(IconV5.make, {
        icon: "calendar",
        size: 20
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("span", {
            children: props.status,
            className: "font-medium"
          }),
          detailText !== undefined ? JsxRuntime.jsx("span", {
              children: ` ` + detailText,
              className: "text-zinc-500"
            }) : null
        ],
        className: `text-zinc-700 ` + (
          size === "sm" ? "text-base" : "text-lg"
        )
      })
    ],
    className: "flex flex-row items-center gap-2"
  });
}

function AgentPropertyMlsStatus$FromMlsPlan(props) {
  let size = props.size;
  let activeOnMlsSince = props.activeOnMlsSince;
  let mlsPlan = RescriptRelay_Fragment.useFragment(AgentPropertyMlsStatus_mlsPlan_graphql.node, convertFragment, props.mlsPlan);
  if (activeOnMlsSince !== undefined) {
    return JsxRuntime.jsx(AgentPropertyMlsStatus$MlsStatus, {
      status: "On-MLS",
      detailText: `since ` + DateFns.format(CalendarDate.toLocalDate(Primitive_option.valFromOption(activeOnMlsSince)), "MMMM d"),
      size: size
    });
  }
  switch (mlsPlan.__typename) {
    case "AlreadyOnMls" :
      return null;
    case "ListOnMlsAsActive" :
      return JsxRuntime.jsx(AgentPropertyMlsStatus$MlsStatus, {
        status: "Off-MLS",
        detailText: `until ` + DateFns.format(CalendarDate.toLocalDate(mlsPlan.onMlsAt), "MMMM d"),
        size: size
      });
    case "ListOnMlsAsComingSoon" :
      return JsxRuntime.jsx(AgentPropertyMlsStatus$MlsStatus, {
        status: "MLS Coming Soon",
        detailText: `going active on ` + DateFns.format(CalendarDate.toLocalDate(mlsPlan.activeOnMlsOn), "MMMM d"),
        size: size
      });
    case "NoMlsPlan" :
      return JsxRuntime.jsx(AgentPropertyMlsStatus$MlsStatus, {
        status: "Off-MLS",
        size: size
      });
    case "__unselected" :
      return UnselectedUnionMemberError.raise(`Unselected mls status ` + mlsPlan._0);
  }
}

let FromMlsPlan = {
  make: AgentPropertyMlsStatus$FromMlsPlan
};

function AgentPropertyMlsStatus$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(AgentPropertyMlsStatus_property_graphql.node, convertFragment$1, props.property);
  return JsxRuntime.jsx(AgentPropertyMlsStatus$FromMlsPlan, {
    mlsPlan: property.mlsPlan.fragmentRefs,
    activeOnMlsSince: property.activeOnMlsSince,
    size: props.size
  });
}

let WithoutErrorBoundary = {
  make: AgentPropertyMlsStatus$WithoutErrorBoundary
};

function AgentPropertyMlsStatus(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "MLS status",
    children: JsxRuntime.jsx(AgentPropertyMlsStatus$WithoutErrorBoundary, {
      property: props.property,
      size: props.size
    })
  });
}

let make = AgentPropertyMlsStatus;

exports.FromMlsPlan = FromMlsPlan;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* IconV5 Not a pure module */
